import { domtify } from "@/core.js"
import { getIn } from "@/utils/object.js"

domtify.getIn = getIn
